import md5 from 'js-md5';

/**
 * @param jsonData
 * */
export function paramsStringify(jsonData = {}) {
  const paramArray = [];
  let data = '';
  Object.keys(jsonData).forEach((i) => {
    switch (typeof jsonData[i]) {
      case 'string':
        data = jsonData[i].trim();
        break;
      case 'undefined':
        data = '';
        break;
      default:
        data = jsonData[i];
        break;
    }
    paramArray.push(`${i}=${encodeURIComponent(data)}`);
  });
  return paramArray.join('&');
}
/**
 * @param name
 * @param url
* */
export function getParameterByName(name, url = window.location.href) {
  // eslint-disable-next-line
  const newName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const passwordToMd5 = (password) => {
  const str = 'VcUv9JRoEorV&W*visOXWzZAfbD9FQM7';
  return md5(md5(`${str}${password}`));
};

// 将数字转为千分法数字，可迭代的结构
export const formatNum = (inputValue) => {
  if (parseFloat(inputValue) !== inputValue
    || !inputValue
    || Number.isNaN(inputValue)) {
    return {
      success: false,
      result: inputValue,
    };
  }
  const [integer, decimal] = String(inputValue).split('.');
  // if (integer.length <= 3) {
  //   return {
  //     success: false,
  //     result: inputValue,
  //   };
  // }
  const result = [];
  const integerArr = integer.split('').reverse();
  integerArr.forEach((item, index) => {
    result.push({
      type: 'int',
      value: item,
    });
    if ((index + 1) % 3 === 0 && [0, integer.length - 1].indexOf(index) === -1) {
      result.push({
        type: 'comma',
        value: ',',
      });
    }
  });
  if (decimal) {
    result.unshift({
      type: 'float',
      value: `.${decimal}`,
    });
  }
  return {
    success: true,
    result: result.reverse(),
  };
};

// 跳转主页逻辑
export const toIndexRoute = (menuList, $router, routeName = '') => {
  // 客户
  if (menuList.includes('account')) {
    if (routeName !== 'dashboard-accountView') {
      $router.push({
        name: 'dashboard-accountView',
      });
    }
    return 'customer';
  }
  if (menuList.includes('settlement_contract')) {
    if (routeName !== 'dashboard-settlement-contract') {
      $router.push({
        name: 'dashboard-settlement-contract',
      });
    }
    return 'business';
  }

  if (menuList.includes('payment')) {
    if (routeName !== 'dashboard-settlement-payment') {
      $router.push({
        name: 'dashboard-settlement-payment',
      });
    }
    return 'accounting';
  }
  // 默认认为是客户登录
  $router.push({
    name: 'index',
  });
  return 'customer';
};
